import type { IconSvgObject } from './types';

const SnailIcon: IconSvgObject = [
  ["path", { d: "M9.61133 14C9.61133 16.5 11.5291 20 15.5579 20C19.5866 20 22 16.866 22 13C22 8.02944 17.7817 4 12.0891 4C6.45839 4 1.41446 8.86874 2.0551 16C4.74641 16.6822 8.22598 15.8637 9.61133 14ZM9.61133 14C9.61133 8.87223 17.5401 7.79116 17.5401 13C17.5401 14.4689 16.5152 15.7264 15.0623 16.2456", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default SnailIcon;
